import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 356.89 107.135" {...props}><path data-name="Path 193" d="M356.89 107.135H0S25.931 0 118.736 0c68.239 0 103.723 42.99 118.054 65.509 26.613-10.918 84.617-23.2 120.1 41.626" /></svg>);